import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en.json";
import arTranslation from "./ar.json";
import hiTranslation from "./hi.json";

const resources = {
  en: enTranslation,
  ar: arTranslation,
  hi: hiTranslation,
};

const RTL_LANGS = ["ar"];

// Real document-level direction flip (drives MUI RTL cache + native
// scrollbars/selection, on top of the existing per-component isArabic
// flex-direction overrides which stay as-is).
const applyDocumentDirection = (locale) => {
  if (typeof document === "undefined") return;
  const dir = RTL_LANGS.includes(locale) ? "rtl" : "ltr";
  document.documentElement.dir = dir;
  document.documentElement.lang = locale;
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    localePath: "locales",
    lng: "en",
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

applyDocumentDirection(i18n.language);

// const i18n = new I18n({ ...translations, locale: "ar" });
// i18n.locale = "en" || "ar";

const changeLanguage = (locale) => {
  i18n.changeLanguage(locale);
  applyDocumentDirection(locale);
};

const isRtl = (locale) => RTL_LANGS.includes(locale);

export { changeLanguage, isRtl };
